import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useSystemsContext } from '../../context/SystemsContext';

const SavingModal: React.FC = () => {
  const { isSaving } = useSystemsContext();

  // If we are not saving, render nothing.
  if (!isSaving) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          background: 'white',
          borderRadius: '12px',
          padding: '32px 48px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          boxShadow: 3,
        }}
      >
        <CircularProgress size={48} />
        <Typography variant="h6" sx={{ mt: 2, color: 'text.primary' }}>
          Saving changes...
        </Typography>
      </Box>
    </Box>
  );
};

export default SavingModal;